import Vue from 'vue';
import axios, { CancelToken } from 'axios/dist/axios';
import { getQueryVariable, getIframeQueryVariable, convertToCapitalizedCamelCase, convertToSnakeCase } from '../util';
import { ERROR_CODE } from '@/constants';
import { addEnvHeader } from './util';

let source = CancelToken.source();

// 创建axios实例
const service = axios.create({
    baseURL: process.env.API_BASE_URL,
    timeout: 600 * 1000,
    withCredentials: true
});

const requestInterceptorFun = (config) => {
    config.cancelToken = source.token; // 全局cancelToken

    // 仅知识平台的业务接口需要走下面的逻辑。
    if (config.url) {
        const bot_biz_id = window.localStorage.getItem('bot_biz_id_im') || getQueryVariable('bot_biz_id');
        const seat_biz_id = window.localStorage.getItem('seat_biz_id_im') || getQueryVariable('seat_biz_id');
        const session_id = window.localStorage.getItem(`session_id_im_${bot_biz_id}_${seat_biz_id}`);
        console.log('session_id', session_id);
        const from = getIframeQueryVariable('from');
        const token = getIframeQueryVariable('token');
        let fromServiceType;

        if (from === 'ivh_ipaas_isv_eg' && token && from) {
            fromServiceType = 'ivh';
        }

        config.data = {
            from,
            token,
            regionId: 1,
            serviceType: 'lke',
            cmd: config.url,
            data: convertToCapitalizedCamelCase(config.method === 'get' ? config.params : config.data)
        };
        fromServiceType && (config.data.fromServiceType = fromServiceType);
        config.method = 'post';
        config.params = {
            cmd: config.url
        };
    } else {
        // 其它接口带上cmd
        config.params = {
            cmd: config.data.cmd
        };
    }
    config = addEnvHeader(config);
    config.url = '';
    return config;
};

// request拦截器
service.interceptors.request.use(requestInterceptorFun, error => {
    console.log('【request error】' + error);
    Promise.reject(error);
});

// respone拦截器
service.interceptors.response.use((response) => {
    const code = response.data.code;

    /**
     * api代理返回19001,表示鉴权错误。例如：无登录态，或登录态失效
     */
    if (code === 19001) {
        // 跳转腾讯云登录页
        toLoginPage();
        return;
    }
    let data = response.data.data.Response;

    // 获取cos文件，返回data为string内容
    if (Object.prototype.toString.call(data) === '[object String]') {
        return Promise.resolve(data);
    }

    if (data.Error) {
        const { Message = '' } = data.Error;
        // 分享链接失效时，需要特殊处理，展示链接失效页
        if (Message.includes(ERROR_CODE.INVALID_SHARECODE)) {
            return Promise.reject(ERROR_CODE.INVALID_SHARECODE); // 抛出异常
        }
        handleError(data.Error, response.config.data);
        return Promise.reject(data.Error); // 抛出异常
    }
    // 只有业务response才需要转成snake_case
    if (JSON.parse(response.config.data).serviceType === 'lke') {
        data = convertToSnakeCase(data);
        // 将原始 response 保留一份在 data 中
        // 后续业务可能会用到当时这个请求参数比如 response.config.params / response.config.data
        data.__ORIGINAL_REQUEST = JSON.parse(response.config.data);
    }

    return Promise.resolve(data);
}, error => {
    if (axios.isCancel(error)) {
        console.log('【isCancel error】');
        return new Promise(() => { });
    } else {
        if (error.response) {
            const { data } = error.response;
            data.msg = data.message;
            console.log('【response error】' + JSON.stringify(data));
            return Promise.reject(data);
        }
        return Promise.reject(error);
    }
});

export const getLoginHref = (quit = false) => {
    const { protocol, hostname, href } = window.location;
    const cloudHostname = hostname.substring(hostname.indexOf('cloud'));
    const url = `${protocol}//${cloudHostname}/login${quit ? '/quit' : ''}?s_url=${encodeURIComponent(href)}`;
    return url;
};

export const toLoginPage = (quit = false) => {
    window.location.href = getLoginHref(quit);
};

export const handleError = ({ Code, Message }, params) => {
    // 报错提示
    Vue.prototype.$message.error(Message, JSON.parse(params));

    if (Message.includes(ERROR_CODE.LOGIN_FAIL)) { // 用户未登录 业务没有登录态
        source.cancel();
        setTimeout(() => {
            source = CancelToken.source();
            // request拦截器
            service.interceptors.request.use(config => {
                config.cancelToken = source.token; // 全局cancelToken
                return config;
            }, error => {
                console.log('【request error】' + error);
                // Promise.reject(error);
            });
            // 跳转腾讯云登录页
            toLoginPage(true);
        }, 1000);
        return new Promise(() => { });
    } else if (Message.includes(ERROR_CODE.ROBOT_NOT_EXIST)) { // 机器人不存在
        Vue.prototype.$message.error(Message || '获取会话ID失败，请重试');
        return new Promise(() => { });
    } else if (Message.includes(ERROR_CODE.AUTH_FAIL)) { // 权限不足
        console.log('error:', '权限不足');
        return new Promise(() => { });
    }
};
export default service;



// WEBPACK FOOTER //
// ./src/utils/ajax/cloud.js